var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32 4.328c-2.202 1.665-4.095 4.5-4.767 5.708.645 0 3.447-.761 4.768-1.142l1.881 2.015c-.2.738-.361 2.631.606 4.297.967 1.665 5.058 3.738 6.983 4.566-.426.134-1.532.833-2.552 2.552-1.276 2.148-.202 4.633 1.611 6.513 1.45 1.505 3.737 1.523 4.7 1.343.671.472 2.579.86 4.835-1.342 2.256-2.202 3.313-4.185 3.559-4.902h-1.209l.806-1.208h1.008c.582-.672 1.68-3.05 1.41-7.186-.335-5.17-3.559-9.67-8.998-12.356-4.351-2.148-8.931-.895-10.677 0-.403-.313-1.76-.523-3.962 1.142z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.553 23.936C.297 19.424.986 13.998 1.613 11.85a205.96 205.96 0 0 1 6.245 8.326c2.633 3.707 2.395 8.438 1.948 10.341-1.478-.313-4.996-2.068-7.253-6.58z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrt);
export default __webpack_public_path__ + "static/media/KRT.a66d7bf6867cc9fcf5443e0a843d08f4.svg";
export { ForwardRef as ReactComponent };